module.exports = __webpack_public_path__ + "img/patient-info-desktop-ru.9a88e93c.jpg";